module.exports = __webpack_public_path__ + "static/media/img_8.fb91763d.png";